/**
 * Baluchistan Region Data
 * Comprehensive data for the Baluchistan region (spanning Iran and Pakistan)
 */

import { Region } from "../../types/regions";

/**
 * Greater Baluchistan region (cultural/ethnic region spanning Iran and Pakistan)
 * Note: This represents the Baloch-majority areas, not a political boundary
 */
export const BALUCHISTAN_REGION: Region = {
  id: "region-baluchistan",
  code: "baluchistan",
  name: "Baluchistan",
  localizedNames: {
    en: "Baluchistan",
    fa: "بلوچستان",
    ar: "بلوشستان",
    bal: "بلوچستان",
    ur: "بلوچستان",
  },
  description: "The Baluchistan region, homeland of the Baloch people, spanning southeastern Iran and southwestern Pakistan",
  // Note: Baluchistan is a cultural region without official borders, so no border data is available

  viewport: {
    center: { lat: 27.5, lng: 64.0 },
    zoom: 6,
    minZoom: 5,
    maxZoom: 18,
  },

  area: 347190, // Approximate square kilometers (estimates vary)

  status: "hidden",
  visibility: "admin",

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "satellite",
  themeColor: "#c41e3a", // Red (common in Baloch symbolism)
  flagEmoji: "⭐", // Star symbol
  thumbnailUrl: "/images/regions/baluchistan-thumbnail.jpg",

  historicalPeriods: [
    {
      id: "ancient",
      name: "Ancient Baluchistan",
      startYear: -3000,
      endYear: 600,
      description: "Early civilizations in the Baloch lands",
    },
    {
      id: "khanates",
      name: "Baloch Khanates",
      startYear: 1500,
      endYear: 1839,
      description: "Period of Baloch confederacies and khanates, including Kalat",
    },
    {
      id: "british-era",
      name: "British Period",
      startYear: 1839,
      endYear: 1947,
      description: "British influence and the incorporation into British India",
    },
    {
      id: "modern",
      name: "Modern Era",
      startYear: 1947,
      endYear: undefined,
      description: "Division between Iran and Pakistan",
    },
  ],

  parentRegions: [
    "region-iran",
    "region-pakistan",
  ],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 5,
  tags: ["baloch", "multi-country", "cultural-region", "desert"],
};

